// RFC 5322 Standard Email
const EMAIL_REGEX = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i;
export default (({
  message = 'Please enter a valid email.'
} = {}) => value => {
  if (!EMAIL_REGEX.test(value)) {
    return message;
  }
  return null;
});